<script lang="ts">
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	// Design System Components
	// Types
	import type { Device } from 'src/types/Device.ts';
	import InputsReaderVisualizerV2 from 'src/components/Controls/Indicators/InputsReaderVisualizerV2.svelte';
	import LastReporterV2 from 'src/components/Drawer/LastReporterV2.svelte';
	import DeviceViewStateWrapper from '../DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	import { real_id } from 'src/helpers/interface_helpers';
	import {
		canShowGen1LabelList,
		createGen1CombinedLabelList,
		createGen1StatusLabels,
		getGen1DeviceStatuses,
	} from '../../SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';
	import { devices_config } from '@devices/index';

	export let device: Device;

	let timerLabels: Record<string, any> = {};

	$: deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses, device);

	$: combinedLabelList = createGen1CombinedLabelList(timerLabels, labelList);
</script>

<DeviceViewStateWrapper {device}>
	<div class="label-list-wrapper mb-s" slot="staticTop">
		{#if canShowGen1LabelList(device, status)}
			<DeviceLabelList labelList={combinedLabelList} />
		{/if}
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>

	<div class="flex-full-height justify-content-end" slot="staticBottom">
		{#if !device.shared}
			<LastReporterV2 class="mb-s" {device} />
		{/if}
		<InputsReaderVisualizerV2 {device} {status} {settings} isInCard={false} />
	</div>
</DeviceViewStateWrapper>
